import { ClipboardIcon } from '@heroicons/react/24/solid';
import React from 'react';
export default function DocumentIconSolid(props) {
  return <ClipboardIcon className={props?.class} />;
}
